import { DatePicker, Form, Input, Select } from 'antd';
import moment from 'moment';
import React, { PureComponent } from 'react';
import { API_DATE_FS } from './shared';

const PROFESSIONAL_INSURANCE_TYPES = [
  'Professional Indemnity',
];

const VALID_STATES = ['NSW', 'QLD', 'NT', 'SA', 'ACT', 'WA', 'TAS', 'VIC', 'NZ'];

export class ProfInsurancePIFormItems extends PureComponent {
  static slug = 'profinspi';

  constructor(props) {
    super(props);
    this.state = {};
  }

  static getSubmissionData(checkData, constituent) {
    return {
      identifier: checkData.identifier,
      insurance_type: checkData.insurance_type,
      ...(checkData.state && { state: checkData.state }),
      issued_by: checkData.issued_by,
      expiry: checkData.expiry.format(API_DATE_FS),
      ...(checkData.insured_amount && { insured_amount: checkData.insured_amount }),
      ...(checkData.conditions && { conditions: checkData.conditions }),
      fullName: constituent.get('fullName'),
    };
  }

  disablePastDate = current => current && current < moment().endOf('day');

  render() {
    const { form, disabled, rules } = this.props;
    const { getFieldDecorator } = form;
    const { slug } = this.constructor;

    const ident = {
      label: 'Identifier',
      slug: `${slug}.identifier`,
    };
    const insurance_type = {
      label: 'Insurance Type',
      slug: `${slug}.insurance_type`,
    };
    const state = {
      label: 'State / Country',
      slug: `${slug}.state`,
    };
    const issued_by = {
      label: 'Issued By',
      slug: `${slug}.issued_by`,
    };
    const insured_amount = {
      label: 'Insured Amount ($)',
      slug: `${slug}.insured_amount`,
    };
    const conditions = {
      label: 'Conditions',
      slug: `${slug}.conditions`,
    };
    const expiry = {
      label: 'Expiry',
      slug: `${slug}.expiry`,
    };

    return (
      <>
        <Form.Item label={insurance_type.label}>
          {getFieldDecorator(insurance_type.slug, {
            rules: [
              {
                required: true,
                whitespace: true,
                message: `${insurance_type.label} is required`,
              },
              ...(rules || []),
            ],
          })(
            <Select
              showSearch
              disabled={disabled}
              optionFilterProp="children"
              filterOption={(input, option) => option.props.children
                .toString()
                .toLowerCase()
                .includes(input.toLowerCase())
              }
            >
              {PROFESSIONAL_INSURANCE_TYPES.map(type => (
                <Select.Option key={type} value={type}>
                  {type}
                </Select.Option>
              ))}
            </Select>,
          )}
        </Form.Item>
        <Form.Item label={ident.label}>
          {getFieldDecorator(ident.slug, {
            rules: [
              {
                required: true,
                whitespace: true,
                message: `${ident.label} is required`,
              },
              ...(rules || []),
            ],
          })(<Input disabled={disabled} />)}
        </Form.Item>
        <Form.Item label={state.label}>
          {getFieldDecorator(state.slug, {
            rules: [
              ...(rules || []),
            ],
          })(
            <Select
              showSearch
              disabled={disabled}
              optionFilterProp="children"
              filterOption={(input, option) => option.props.children
                .toString()
                .toLowerCase()
                .includes(input.toLowerCase())
              }
            >
              {VALID_STATES.map(member => (
                <Select.Option key={member} value={member}>
                  {member}
                </Select.Option>
              ))}
            </Select>,
          )}
        </Form.Item>
        <Form.Item label={issued_by.label}>
          {getFieldDecorator(issued_by.slug, {
            rules: [
              {
                required: true,
                whitespace: true,
                message: `${issued_by.label} is required`,
              },
              ...(rules || []),
            ],
          })(<Input disabled={disabled} />)}
        </Form.Item>
        <Form.Item label={expiry.label}>
          {getFieldDecorator(expiry.slug, {
            rules: [
              {
                required: true,
                message: `${expiry.label} is required`,
              },
              ...(rules || [])],
          })(
            <DatePicker
              format="DD-MM-YYYY"
              placeholder="DD-MM-YYYY"
              disabled={disabled}
              disabledDate={this.disablePastDate}
            />,
          )}
        </Form.Item>
        <Form.Item label={insured_amount.label}>
          {getFieldDecorator(insured_amount.slug, {
            rules: [
              ...(rules || []),
            ],
          })(<Input disabled={disabled} />)}
        </Form.Item>
        <Form.Item label={conditions.label}>
          {getFieldDecorator(conditions.slug, {
            rules: [
              ...(rules || []),
            ],
          })(<Input disabled={disabled} />)}
        </Form.Item>
      </>
    );
  }
}
